import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from '@angular/common';
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { forkJoin as observableForkJoin, throwError as observableThrowError, Observable, of } from 'rxjs';
import { first, map, catchError } from 'rxjs/operators';

import { IconActionRendererComponent } from "../../../common/components/ag-grid/icon-action-renderer.component";

import { AuthService } from "../../../services/auth.service";
import { DialogService } from "../../../common/services/dialog.service";
import { EntityBuilderService } from "../../../builder/services/entity-builder.service";
import { LoaderService } from "../../../common/services/loader.service";
import { SubHeaderService } from "../../../core/services/sub-header.service";

import { entityListValidator } from "../../../entity-builder/directives/unique-entity.directive";

import { SubHeader } from "../../../core/models/sub-header.model";
import { LunaEntity } from "../../../builder/models/entity.model";
import { ContactService, ContactSearchSpec } from "../../../admin/services/contacts.service";
import { ContactStub } from "../../../admin/models/contact.model";
import { dateComparator } from "../../../common/components/data-table/comparators/data-table.comparators";
import { OrganizationService } from "../../../common/services/organization.service";
import { GridFormatterService } from "../../../common/services/grid-formatter.service";

@Component({
    selector: "entitylist",
    templateUrl: "./entitylist.component.html",
    standalone: false
})
//export const entityList = new Array<LunaEntity>();
export class EntityListComponent implements OnInit {

  public createEntityForm: FormGroup;
  public showListError: boolean = false;
  public subHeader = new SubHeader({ title: "Entity Builder" });
  public entityList = new Array<LunaEntity>();
  public _entity = {
    entityName: "",
    description: "",
    collectionName: "",
    schemaObject: {
      title: "",
      type: "object",
      properties: {}
    }
  } as LunaEntity;
    public entity: LunaEntity;
	public gridOptions: GridOptions;
	private gridApi?: GridApi;
    public columnDefs: ColDef[] = [
    {
        headerName: "Name",
        headerTooltip: "Name",
        field: "entityName",
        tooltipField: "entityName",
    },
    {
        headerName: "Created By",
        headerTooltip: "Created By",
        field: "createContactName",
        tooltipField: "createContactName",
    },
    {
        headerName: "Created Date",
        headerTooltip: "Created Date",
        field: "createDate",
        tooltipValueGetter: this.dateFormatter(this, "createDate"),
        valueGetter: this.dateFormatter(this, "createDate"),
        comparator: dateComparator,
    },
    {
        headerName: "Last Edited By",
        headerTooltip: "Last Edited By",
        field: "editContactName",
        tooltipField: "editContactName",
    },
    {
        headerName: "Edited Date",
        headerTooltip: "Edited Date",
        field: "updateDate",
        tooltipValueGetter: this.dateFormatter(this, "updateDate"),
        valueGetter: this.dateFormatter(this, "updateDate"),
        comparator: dateComparator,
    },
    {
      headerName: "",
      field: "",
      cellStyle: { 'text-align': 'right', 'line-height': 1.75 },
      cellRenderer: IconActionRendererComponent,
      cellRendererParams: {
        buttons: [
          {
            action: (obj) => this.editEntity(obj),
            label: 'Edit Entity',
            icon: 'edit'
          },
          {
            action: (obj) => this.deleteEntity(obj),
            label: 'Delete Entity',
            icon: 'delete'
          },

        ]
      }
    }
  ];

  constructor(
    public readonly subHeaderService: SubHeaderService,
    public ebService: EntityBuilderService,
    public contactService: ContactService,
    public organizationService: OrganizationService,
    public loaderService: LoaderService,
    public router: Router,
    public authService: AuthService,
    public dialogService: DialogService,
    public datePipe: DatePipe,
    public gridFormatterService: GridFormatterService
  ) {
      subHeaderService.updateSubHeader(this.subHeader);
	  this.gridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.columnDefs);
	  this.gridOptions.onGridReady = (params) => { this.gridApi = params.api; };
  }

  ngOnInit() {
    this.loadEntityList();
    this.createEntityForm = new FormGroup({
      'name': new FormControl(this._entity.entityName, [
        Validators.required,
        Validators.minLength(4),
        entityListValidator(this.entityList)
      ]),
      'desc': new FormControl(this._entity.description, [
        Validators.required,
        Validators.minLength(4)
      ]),
    });
  }

  public editEntity(entity: LunaEntity): void {
    this.router.navigate([`/entitybuilder/entity/${entity.id}`]);
  }

  public deleteEntity(entity: LunaEntity): void {
    this.entity = entity;
    this.dialogService.openDialog("yesNo", `Are you sure you want to delete ${entity.entityName}?<br> The entire entity will be deleted.`, "deleteEntity");
  }

  public setEntityContactNames(): any {

      let contactIds: string[] = [];
      //pull the contactIds off the entities;
      this.entityList.forEach(e => {
          if (!(contactIds.filter(id => id == e.createContactID).length > 0))
              contactIds.push(e.createContactID)

          if (!(contactIds.filter(id => id == e.editContactID).length > 0))
              contactIds.push(e.editContactID)
      });

      this.contactService.getAll({ ids: contactIds, stubs: true } as ContactSearchSpec).subscribe(
          results => {
              this.entityList.forEach(e => {
                  let createContact = results.filter(a => a.id == e.createContactID);
                  if (createContact.length > 0)
                      e.createContactName = createContact[0].displayName
                  else e.createContactName = "Unknown";

                  let editContact = results.filter(a => a.id == e.editContactID);
                  if (editContact.length > 0)
                      e.editContactName = editContact[0].displayName;
                  else e.editContactName = "Unknown";
              });
              if (this.gridApi)
                this.gridApi.setGridOption("rowData", this.entityList);
          },
          (error) => {
              console.log(error);
          });
  }

  public loadEntityList(): void {
    this.loaderService.toggleLoader(true);
    this.ebService.getActive().pipe(first()).subscribe(response => {
        this.entityList = response;
        this.entityList.forEach(e => { e.createContactName = "Loading..."; e.editContactName = "Loading..." })
		this.gridApi.setGridOption("rowData", this.entityList);
		this.gridApi.sizeColumnsToFit();
    }, (error) => {
      this.loaderService.toggleLoader(false);
      this.showListError = true;
      console.log(error);
    }, () => {
            this.setEntityContactNames();
		this.gridApi.setGridOption("rowData", this.entityList);
            this.loaderService.toggleLoader(false);
      });
  }

  public saveEntity(): void {
    this._entity.entityName = this.createEntityForm.value.name;
    this._entity.description = this.createEntityForm.value.desc;
    this._entity.schemaObject.title = this.createEntityForm.value.name;
    this._entity.collectionName = this.createEntityForm.value.name;
    this.save(this._entity);
  }

  public save(entity: LunaEntity): void {
    this.ebService.post(entity).subscribe((entity: LunaEntity) => {
      //Do nothing
    }, (error) => {
      console.log(error);
      this.dialogService.openDialog("exit", "You are not authorized to modify this entity.", "notAuthorized");
    }, () => {
      this.router.navigate([`/entitybuilder/entity/${entity.id}`]);
    });
    }

  public dateFormatter(component: any, field: string) {
    return (obj) => component.datePipe.transform(obj.data[field], 'MM/dd/yyyy');
  }

  get name() { return this.createEntityForm.get('name'); }
  get desc() { return this.createEntityForm.get('desc'); }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    if (this.dialogService.dialogId === 'deleteEntity') {
      this.loaderService.toggleLoader(true);
      this.entity.isDelete = true;
      this.ebService.post(this.entity).subscribe(entity => {
        this.loaderService.toggleLoader(false);
        this.loadEntityList();
      }, (error) => {
        console.log(error);
        this.loaderService.toggleLoader(false);
      });
    } else if (this.dialogService.dialogId === 'notAuthorized') {
      this.router.navigate(["/entitybuilder/list"]);
    }
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
